import { gql } from '@apollo/client'

export const GET_TAG_BY_ID = gql`
  query GetTagByIdFront($input: oGetTagByIdFrontInput) {
    getTagByIdFront(input: $input) {
      _id
      eType
      sContent
      sName
      bIsFav
    }
  }
`

export const GET_PLAYER_BY_ID = gql`
  query GetPlayerByIdFront($input: oGetPlayerByIdFrontInput) {
    getPlayerByIdFront(input: $input) {
      _id
      aMajorTeams {
        sTitle
        sTeamType
        oImg {
          sUrl
        }
        oSeo {
          eStatus
          sSlug
        }
      }
      aRanking {
        nRank
        nRating
        eMatchType
        eRankType
      }
      dBirthDate
      eTagStatus
      oImg {
        sUrl
        sAttribute
      }
      oSeo {
        _id
        sSlug
      }
      oTeam {
        _id
        sTitle
        sAbbr
        oImg {
          sText
          sCaption
          sAttribute
          sUrl
        }
      }
      oSocialMedia {
        oFacebook {
          sUrl
          sHandle
        }
        oInstagram {
          sHandle
          sUrl
        }
        oTwitter {
          sHandle
          sUrl
        }
        oWikipedia {
          sHandle
          sUrl
        }
      }
      sBattingStyle
      sBirthPlace
      sBowlingStyle
      sCountryFull
      sFirstName
      sFullName
      sNationality
      sPlayingRole
      sShortName
      bIsCustomPlayerDescription
      sCustomPlayerDescription
    }
  }
`

export const FETCH_PLAYER_STATS = gql`
  query FetchPlayerStats($input: ofetchPlayerStats) {
    fetchPlayerStats(input: $input) {
      _id
      iPlayerId
      oBatting {
        test {
          nMatches
          nInnings
          nNotOut
          nRuns
          nBalls
          nHighest
          nRun100
          nRun50
          nRun4
          nRun6
          sAverage
          sStrike
          nCatches
          nStumpings
          nFastest50balls
          nFastest100balls
        }
        odi {
          nMatches
          nInnings
          nNotOut
          nRuns
          nBalls
          nHighest
          nRun100
          nRun50
          nRun4
          nRun6
          sAverage
          sStrike
          nCatches
          nStumpings
          nFastest50balls
          nFastest100balls
        }
        t20i {
          nMatches
          nInnings
          nNotOut
          nRuns
          nBalls
          nHighest
          nRun100
          nRun50
          nRun4
          nRun6
          sAverage
          sStrike
          nCatches
          nStumpings
          nFastest50balls
          nFastest100balls
        }
        t20 {
          nMatches
          nInnings
          nNotOut
          nRuns
          nBalls
          nHighest
          nRun100
          nRun50
          nRun4
          nRun6
          sAverage
          sStrike
          nCatches
          nStumpings
          nFastest50balls
          nFastest100balls
        }
        firstclass {
          nBalls
          sStrike
          sAverage
          nStumpings
          nRuns
          nRun50
          nRun6
          nRun4
          nRun100
          nNotOut
          nMatches
          nInnings
          nHighest
          nFastest50balls
          nFastest100balls
          nCatches
        }
        lista {
          nBalls
          nCatches
          nFastest100balls
          nFastest50balls
          nMatches
          nInnings
          nHighest
          nNotOut
          nRun50
          nRun4
          nRun100
          sStrike
          sAverage
          nStumpings
          nRuns
          nRun6
        }
        t10 {
          nMatches
          nInnings
          nNotOut
          nRuns
          nBalls
          nHighest
          nRun100
          nRun50
          nRun4
          nRun6
          sAverage
          sStrike
          nCatches
          nStumpings
        }
      }
      oBowling {
        test {
          nMatches
          nInnings
          nBalls
          nOvers
          nRuns
          nWickets
          sBestinning
          sBestmatch
          sAverage
          sStrike
          nWicket4i
          nWicket5i
          nWicket10m
          nHattrick
          nExpensiveOverRuns
          sEcon
        }
        odi {
          nMatches
          nInnings
          nBalls
          nOvers
          nRuns
          nWickets
          sBestinning
          sBestmatch
          sAverage
          sStrike
          nWicket4i
          nWicket5i
          nWicket10m
          nHattrick
          nExpensiveOverRuns
          sEcon
        }
        t20i {
          nMatches
          nInnings
          nBalls
          nOvers
          nRuns
          nWickets
          sBestinning
          sBestmatch
          sAverage
          sStrike
          nWicket4i
          nWicket5i
          nWicket10m
          nHattrick
          nExpensiveOverRuns
          sEcon
        }
        t20 {
          nMatches
          nInnings
          nBalls
          nOvers
          nRuns
          nWickets
          sBestinning
          sBestmatch
          sAverage
          sStrike
          nWicket4i
          nWicket5i
          nWicket10m
          nHattrick
          nExpensiveOverRuns
          sEcon
        }
        firstclass {
          nMatches
          nInnings
          nBalls
          nOvers
          nRuns
          nWickets
          sBestinning
          sBestmatch
          sAverage
          sStrike
          nWicket4i
          nWicket5i
          nWicket10m
          nHattrick
          nExpensiveOverRuns
          sEcon
        }
        lista {
          nMatches
          nInnings
          nBalls
          nOvers
          nRuns
          nWickets
          sBestinning
          sBestmatch
          sAverage
          sStrike
          nWicket4i
          nWicket5i
          nWicket10m
          nHattrick
          nExpensiveOverRuns
          sEcon
        }
        t10 {
          nMatches
          nInnings
          nBalls
          nOvers
          nRuns
          nWickets
          sBestinning
          sBestmatch
          sAverage
          sStrike
          nWicket4i
          nWicket5i
          nWicket10m
          sEcon
        }
      }
      sPlayerKey
    }
  }
`

export const IS_TAG_FAVORITE = gql`
  query GetTagByIdFront($input: oGetTagByIdFrontInput) {
    getTagByIdFront(input: $input) {
      bIsFav
    }
  }
`

export const GET_TAG_ARTICLE = gql`
  query GetTagArticlesFront($input: oGetTagArticlesFrontInput) {
    getTagArticlesFront(input: $input) {
      aResults {
        _id
        sDescription
        sTitle
        sSubtitle
        dPublishDate
        sSrtTitle
        nDuration
        oTImg {
          sUrl
          sCaption
          sText
        }
        oImg {
          sUrl
          sText
          sCaption
          sAttribute
        }
        oSeo {
          sSlug
        }
      }
    }
  }
`

export const GET_RECENT_MATCH_PLAYER = gql`
  query GetRecentMatchesOfPlayer($input: getRecentMatchesOfPlayerInput) {
    getRecentMatchesOfPlayer(input: $input) {
      oMatchPerformance {
        sBlowerScore
        sBatterScore
      }
      oMatch {
        oTeamScoreA {
          oTeam {
            sTitle
            oImg {
              sUrl
            }
            sAbbr
          }
        }
        oTeamScoreB {
          oTeam {
            sTitle
            oImg {
              sUrl
            }
            sAbbr
          }
        }
        oVenue {
          sName
        }
        dStartDate
        sFormatStr
        _id
      }
    }
  }
`
